import axios from 'axios'
import router from '../router'
import Swal from 'sweetalert2'
// import store from '../store'


const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
})

const cancelSource = axios.CancelToken.source();

client.interceptors.request.use(
  config => {
    const token = localStorage.getItem("accessToken")
    if (token) {
      config.headers.common.Authorization = 'bearer' + token;
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

client.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    console.log(error)
    if (error.response && error.response.status === 401) {
      // store.dispatch('logout')
    }
    if (error.response && error.response.status === 403) {
      const message = (error.response.data && error.response.data.error && error.response.data.error.message) || 'Դուք իրավունք չունեք կատարել այս գործողությունը'
      Swal.fire({
        icon: 'error',
        text: message,
        confirmButtonText: 'Լավ',
        buttonsStyling: false,
        customClass: {
          popup: 'card',
          confirmButton: 'btn btn-primary',
        },
      }).then(() => {
        if (router.currentRoute.path !== '/dashboard') {
          router.push('/dashboard')
        }
      })
    }
    return Promise.reject(error.response || error.message)
  }
);

export default { client, cancelSource }
